module.exports = __webpack_public_path__ + "img/2024big12.de4d3ccf.png";